import createActionTypes from '../constants/utils';

export const GROUPS_TABLE = createActionTypes('GROUPS:GROUPS_TABLE');
export const GROUPS_TABLE_DATA_FIELDS = 'GROUPS:GROUPS_TABLE_DATA_FIELDS';

export const ROOT_GROUP_NAME = '<Root>';

export const GROUP_EDITOR_ACTION = createActionTypes('GROUPS:GROUP_EDITOR_ACTION');
export const GROUP_EDITOR_ACTION_DATA_FIELDS = 'GROUPS:GROUP_EDITOR_ACTION_DATA_FIELDS';
